import { render, staticRenderFns } from "./LvStateArticle.vue?vue&type=template&id=3cc00ea6"
import script from "./LvStateArticle.vue?vue&type=script&lang=js"
export * from "./LvStateArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports